import {injectable} from "inversify";

/**
 * The base interface for all types of log containers
 */
export interface ILogsContainer
{
    /**
     * Adds a log entry to the logs
     * @param logEntry The log entry string to append to the log
     */
    addEntry: (logEntry: string) => void;
    
    /**
     * Gets all the log entries
     * @constructor
     * @returns An array of all log entries
     */
    getAllLogs: () => string[];

    /**
     * Gets all the log entries joined with a delimiter
     * @param delimiter The delimiter to use
     * @returns The combined logs string
     */
    GetAllCombinedLogs: (delimiter: string) => string;
    
    /**
     * Gets the number of log entries we have
     * @constructor
     * @returns Number of log entries
     */
    logsCount: () => number;

    /**
     * Deletes all the logs
     */
    clearLogs: () => void;

    /**
     * Deletes logs from a specific index
     * @param index The index from which we want to clear the logs
     */
    clearLogsFrom: (index: number) => void;
}

@injectable()
export class LogsContainer implements ILogsContainer {
    private logEntries: string[] = []

    constructor(logs: string[] = []) {
        this.logEntries = logs;
    }
    
    addEntry(logEntry: string) {
        this.logEntries.push(`${system.getDotnetCompatibleUTCDate()}${settings.uploaderLogsDelimiter}CLIENT-SIDE: ${logEntry}`)
    }
    
    getAllLogs(): string[] {
        return this.logEntries;
    }

    GetAllCombinedLogs(delimiter = '\n'): string {
        return this.logEntries.join(delimiter);
    }
    
    logsCount(): number {
        return this.logEntries.length;
    }
    
    clearLogs() {
        this.logEntries = [];
    }

    clearLogsFrom(index: number) {
        if (index >= this.logEntries.length) return;
        this.logEntries.splice(index, this.logEntries.length - 1);
    }
}